import React from 'react';
import Section from '@atlaskit/menu/section';
import { CheckboxGroupContext } from '../internal/context/checkbox-group-context';
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */
const DropdownItemCheckboxGroup = props => {
  const {
    children,
    id
  } = props;
  return /*#__PURE__*/React.createElement(CheckboxGroupContext.Provider, {
    value: id
  }, /*#__PURE__*/React.createElement(Section, props, children));
};
export default DropdownItemCheckboxGroup;